import { Box, Button, TextField, Typography } from "@mui/material";

import Grid from "@mui/material/Grid";

import React, { useEffect, useState } from "react";
import {} from "../../utils/utils";
// import Youtube from '../assets/img/icon/youtube.png'
import { useSelector } from "react-redux";
// import { GetBussiness, UpdateBusiness } from "./myBusinessApi";
import DeleteIcon from "@mui/icons-material/Delete";

import { formDataFN, swalAlertPopProps } from "../../utils/commonUtils";
// import { validationsSubmits } from "./myBusinessValidationFunctions";
import {
  getInstitute,
  institueAdd,
  institueUpdate,
} from "../myInstitute/instituteApi";
// import AddModal from "./AddModal";
import {
  franchiseRequirenmentAdd,
  franchiseRequirenmentUpdate,
  getFranchiseRequirenment,
} from "../MyFranchise/franchiseAPI";
import ConfirmDelete from "../Jobs/confirmDelete";
// import { getInstitute, institueAdd, institueUpdate } from "./instituteApi";
import img from "../../assets/categoryCard3.png";
import AddIcon from "@mui/icons-material/Add";

export default function ProductDetails({ setOpen }) {
  const struct = {
    // id: 4,
    title: "",
    territory: "",
    infrastructure: [],
    investmentCosts: [],
    royalties: [],
    staff: [],
  };
  // const [open, setOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [institute, setInstitute] = useState({ ...struct });
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteType, setDeleteType] = useState("");
  const userDetail = useSelector((state) => state.reducer.userDetail);

  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getData = async () => {
    const payload = { billerId: billerId || userDetail?.userMasterId };

    getFranchiseRequirenment(payload, (res) => {
      const obj = res?.data?.data?.list?.[0];
      if (!obj) {
        // NO DATA → RESET FORM FOR ADD
        setInstitute({ ...struct, billerId });
        return;
      }
      setInstitute(obj);

      // console.log(obj);
    });

    // console.log("ll", institute?.instituteName);
  };
  const handleDeleteEducation = (section, index) => {
    if (!section || index === null) return;
    const updatedEducation = institute[section]?.filter((_, i) => i !== index);

    setInstitute((prev) => ({
      ...prev,
      [section]: updatedEducation,
    }));

    franchiseRequirenmentUpdate({
      ...institute,
      [section]: updatedEducation,
    });
  };

  const handleSave = (data) => {
    if (!activeSection) return;

    setInstitute((prev) => ({
      ...prev,
      [activeSection]: [...(prev[activeSection] || []), { value: data.value }],
    }));
  };
  const handleUpdate = (data) => {
    if (editIndex === null || !activeSection) return;

    setInstitute((prev) => {
      const updatedArray = [...prev[activeSection]];
      updatedArray[editIndex] = {
        ...updatedArray[editIndex],
        value: data.value,
      };

      return {
        ...prev,
        [activeSection]: updatedArray,
      };
    });

    setEditIndex(null);
  };

  const submit = async () => {
    const payload = {
      ...institute,
    };
    if (!institute?.id) {
      await franchiseRequirenmentAdd(payload, () => {
        getData();
      });
    } else {
      await franchiseRequirenmentUpdate(payload, () => {
        getData();
      });
    }
  };
  useEffect(() => {
    getData();
  }, []);
  const labelStyle1 = {
    fontWeight: 600,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
    whiteSpace: "nowrap",
  };
  // return <h1>fet</h1>
  return (
    <Grid
      container
      px={{ sm: 4, xs: 2 }}
      pb={4}
      sx={{
        paddingTop: "15px",
        backgroundColor: "#E3E3FF",
        minHeight: "100vh",
      }}
    >
      {/* <DynamicBreadcrumbs /> */}

      <Grid item xs={12}>
        <Grid container>
          <Grid
            item
            xs={12}
            sm={4}
            lg={9}
            md={7}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px 15px",
              mt: { sm: "10px", xs: "1px" },
              borderRadius: "5px",
              color: "#01008B", // optional text color
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },

              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "20px" },
              }}
            >
              Franchise Requirement{" "}
            </Typography>
          </Grid>
          <Grid
            item
            // md={2}
            xs={12}
            sm={4}
            lg={3}
            md={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              fullWidth
              onClick={()=>setOpen(true)}
              sx={{
                textTransform: "capitalize",
                width: {
                  xs: "100%",
                },
                // p: "10px",
                whiteSpace: "nowrap",
                fontSize: {
                  xs: "12px",
                  sm: "13px",
                  md: "15px",
                },
              }}
              color="primary"
              variant="contained"
              aria-label="add"
            >
              Add Product Details
              <AddIcon
                sx={{
                  marginLeft: "6px",
                  fontWeight: 700,
                  fontSize: { xs: "14px", sm: "14px", md: "18px" },
                }}
              />
            </Button>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          sx={{
            margin: 0,
            padding: { xs: "10px", sm: "20px" },
            borderRadius: "10px",
            backgroundColor: "#fff",
            maxHeight: "70vh",
            height: "70vh",
            overflow: "auto",
            pr: { xs: 1, sm: 4 },
          }}
        >
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                backgroundColor: "#fff",
                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Image Section */}
              <Box
                component="img"
                src={img}
                alt="Perfume"
                sx={{
                  width: "100%",
                  height: 180,
                  objectFit: "cover",
                  backgroundColor: "#f5f5f5",
                }}
              />

              {/* Content Section */}
              <Box sx={{ p: 2 }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                >
                  Perfume
                </Typography>

                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "gray",
                    mb: 2,
                  }}
                >
                  Product Id : 01
                </Typography>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    textTransform: "none",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#05054a",
                    },
                  }}
                >
                  Enquiries
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                backgroundColor: "#fff",
                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Image Section */}
              <Box
                component="img"
                src={img}
                alt="Perfume"
                sx={{
                  width: "100%",
                  height: 180,
                  objectFit: "cover",
                  backgroundColor: "#f5f5f5",
                }}
              />

              {/* Content Section */}
              <Box sx={{ p: 2 }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                >
                  Perfume
                </Typography>

                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "gray",
                    mb: 2,
                  }}
                >
                  Product Id : 01
                </Typography>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    textTransform: "none",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#05054a",
                    },
                  }}
                >
                  Enquiries
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                backgroundColor: "#fff",
                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Image Section */}
              <Box
                component="img"
                src={img}
                alt="Perfume"
                sx={{
                  width: "100%",
                  height: 180,
                  objectFit: "cover",
                  backgroundColor: "#f5f5f5",
                }}
              />

              {/* Content Section */}
              <Box sx={{ p: 2 }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                >
                  Perfume
                </Typography>

                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "gray",
                    mb: 2,
                  }}
                >
                  Product Id : 01
                </Typography>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    textTransform: "none",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#05054a",
                    },
                  }}
                >
                  Enquiries
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                backgroundColor: "#fff",
                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Image Section */}
              <Box
                component="img"
                src={img}
                alt="Perfume"
                sx={{
                  width: "100%",
                  height: 180,
                  objectFit: "cover",
                  backgroundColor: "#f5f5f5",
                }}
              />

              {/* Content Section */}
              <Box sx={{ p: 2 }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                >
                  Perfume
                </Typography>

                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "gray",
                    mb: 2,
                  }}
                >
                  Product Id : 01
                </Typography>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    textTransform: "none",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#05054a",
                    },
                  }}
                >
                  Enquiries
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                backgroundColor: "#fff",
                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Image Section */}
              <Box
                component="img"
                src={img}
                alt="Perfume"
                sx={{
                  width: "100%",
                  height: 180,
                  objectFit: "cover",
                  backgroundColor: "#f5f5f5",
                }}
              />

              {/* Content Section */}
              <Box sx={{ p: 2 }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                >
                  Perfume
                </Typography>

                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "gray",
                    mb: 2,
                  }}
                >
                  Product Id : 01
                </Typography>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    textTransform: "none",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#05054a",
                    },
                  }}
                >
                  Enquiries
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Box
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                backgroundColor: "#fff",
                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Image Section */}
              <Box
                component="img"
                src={img}
                alt="Perfume"
                sx={{
                  width: "100%",
                  height: 180,
                  objectFit: "cover",
                  backgroundColor: "#f5f5f5",
                }}
              />

              {/* Content Section */}
              <Box sx={{ p: 2 }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                >
                  Perfume
                </Typography>

                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "gray",
                    mb: 2,
                  }}
                >
                  Product Id : 01
                </Typography>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    textTransform: "none",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#05054a",
                    },
                  }}
                >
                  Enquiries
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      {/* <AddModal
        open={open}
        handleClose={() => {
          setOpen(false);
          setEditIndex(null);
        }}
        activeSection={activeSection}
        onSave={(data) => {
          if (editIndex !== null) {
            handleUpdate(data); // UPDATE
          } else {
            handleSave(data); // ADD
          }
        }}
        editValue={
          editIndex !== null
            ? institute?.[activeSection]?.[editIndex]?.value
            : ""
        }
      /> */}
      <ConfirmDelete
        open={confirmOpen}
        title={
          `Do you want to remove ${deleteType} Detail?`
          // deleteType === "infrastructure"
          //   ? "Do you want to remove infrastructure Detail?"
          //   : "Do you want to remove Experience Detail?"
        }
        onClose={() => {
          setConfirmOpen(false);
          setDeleteIndex(null);
          setDeleteType("");
        }}
        onConfirm={() => {
          handleDeleteEducation(deleteType, deleteIndex);

          setConfirmOpen(false);
        }}
      />
    </Grid>
  );
}
